import { render, staticRenderFns } from "./TicketDataForm.vue?vue&type=template&id=7ffb67c8&"
import script from "./TicketDataForm.vue?vue&type=script&lang=ts&"
export * from "./TicketDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports